import {Routes} from '@angular/router';
import {ChallengeBuilderComponent} from './challenge-builder/challenge-builder.component';
import {ProjectEditComponent} from './edit/project-edit.component';
import {ProjectsListComponent} from './list/projects-list.component';
import {ProjectChallengeWrapperComponent} from './project-challenge-wrapper/project-challenge-wrapper.component';
import {ProjectsComponent} from './projects.component';
import {ProjectViewComponent} from './view/project-view.component';
import {ProjectViewTaskDetailComponent} from './view/task-detail/project-view-task-detail.component';

export const projectsRouting: Routes = [
  {
    path: '',
    component: ProjectsComponent,
    children: [
      {path: '', component: ProjectsListComponent},
      {path: 'view', component: ProjectViewComponent},
      {path: ':projectId/task/:taskId', component: ProjectViewTaskDetailComponent, data: {mobileNavShown: false}},
      {path: 'build', component: ProjectEditComponent},
      {path: 'challenge-builder/:id/:step', component: ChallengeBuilderComponent},
      {path: ':projectId/edit', component: ProjectEditComponent},
      {path: ':projectId', component: ProjectChallengeWrapperComponent},
    ],
  },
];
